import React, { useState } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { SortableList } from "shared/SortableList";
import { SortableItem } from "shared/SortableItem";
import { capitalizeFirstLetter } from "utils/misc";
import ContentBlockField from "./ContentBlockField";
import { ContentBlockType, CONTENT_BLOCK_TYPES } from "../constants";
import { LocalizedContentBlock, emptyLocalizedText } from "../types";
import { useSortableFieldArray } from "../hooks/useSortableFieldArray";

type Props = { partIndex: number };

const ContentSection: React.VFC<Props> = ({ partIndex }) => {
  const { ids, fields, onDragEnd, append, remove } = useSortableFieldArray(
    `parts.${partIndex}.content` as const
  );
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const addBlock = (type: ContentBlockType) => {
    append({ type, content: emptyLocalizedText() } as LocalizedContentBlock);
    setAnchor(null);
  };

  return (
    <Box mt={2}>
      <Box display="flex" alignItems="center" mb={1}>
        <Typography variant="h6">Content</Typography>
        <Box ml={1}>
          <Button startIcon={<Add />} size="small" onClick={e => setAnchor(e.currentTarget)}>
            Add block
          </Button>
          <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
            {CONTENT_BLOCK_TYPES.map(t => (
              <MenuItem key={t} onClick={() => addBlock(t)}>
                {capitalizeFirstLetter(t)}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Box>

      <SortableList items={ids} onDragEnd={onDragEnd}>
        {fields.map((f, i) => {
          const block = f as unknown as LocalizedContentBlock & { _fieldId: string };
          const type: ContentBlockType = block.type ?? "paragraph";
          return (
            <SortableItem key={ids[i]} id={ids[i]} accordion label={`${i + 1}. ${type}`} onRemove={() => remove(i)}>
              <ContentBlockField partIndex={partIndex} blockIndex={i} type={type} />
            </SortableItem>
          );
        })}
      </SortableList>
    </Box>
  );
};

export default ContentSection;
